<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs pos-relative"
	style="min-height: 23em;"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div>
		<!-- Header and downoad icon -->
		<div class="statsHeader">{{ sectiontitle | uppercase }}</div>
		<a
			href="#"
			class="datatable_download_icon"
			*ngIf="downloadConfiguration && downloadConfiguration.enableDownload && hasData"
			(click)="downloadDataInCSV($event)"
			target="_blank"
		>
			<img class="downloadIcon" src="../../../../../assets/creative-assets/download.svg" />
		</a>
	</div>
	<div class="bar-chart">
		<!-- Bar chart -->
		<div style="width: 100%; height: 100%;">
			<div id="chartElement"></div>
		</div>
		<!-- No data display this div -->
		<div class="no-data-container" *ngIf="!hasData && !showLoad">
			<div>
				<div class="statsHeader">{{ sectiontitle | uppercase }}</div>
				<a
					href="#"
					class="datatable_download_icon"
					*ngIf="downloadConfiguration && downloadConfiguration.enableDownload && hasData"
					(click)="downloadDataInCSV($event)"
					target="_blank"
				>
					<img class="downloadIcon" src="../../../../../assets/creative-assets/download.svg" />
				</a>
			</div>
			<div *ngIf="!hasData" class="no-data-daily-stats-chart">
				<div class="no-data-text">No Data Available</div>
			</div>
		</div>
	</div>
</div>
